import { render } from "./UserAccess.vue?vue&type=template&id=68f3ff3c"
import script from "./UserAccess.vue?vue&type=script&lang=js"
export * from "./UserAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__